import { Services } from '@sigma-frontend-libs/commons'

import { components, states } from '@/utils'

import buttonRefresh from '@/components/button/refresh'
import pagination from '@/components/pagination'
import dialog from '@/components/services/sendingsModeration/tasks/dialog'
import item from '@/components/services/sendingsModeration/tasks/item'

function renderPagination(h) {
  return h(
    pagination,
    {
      props: {
        value: this.restData[Services.sendingsModeration].find.pagination,
        selectRows: false,
        service: Services.sendingsModeration
      },
      on: {
        input: event => {
          this.restData[Services.sendingsModeration].find.pagination = event
        }
      }
    }
  )
}
function renderButtonRefresh(h) {
  return h(
    buttonRefresh,
    {
      props: {
        state: this.restData[Services.sendingsModeration].find.state,
        disabled: this.restData[Services.sendingsModeration].find.state === states.loading,
        tooltip: this.getTranslate(`${Services.sendingsModeration}.tooltips.buttons.refresh`),
        shortClickMethod: () => {
          return this.rest[Services.sendingsModeration].find()
        },
        longClickMethod: () => {
          return this.rest[Services.sendingsModeration].find({}, { noCache: true })
        }
      }
    }
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.sendingsModeration}-header`
    },
    [
      renderPagination.call(this, h),
      renderButtonRefresh.call(this, h)
    ]
  )
}

function renderItem(h, value) {
  return h(
    item,
    {
      props: { value },
      on: {
        click: () => {
          this.task = value
          this.showDialog = true
        }
      }
    }
  )
}
function renderItems(h) {
  if (this.restData[Services.sendingsModeration].find.pagination.total > 0) {
    return this.restData[Services.sendingsModeration].find.data.map(task => {
      return renderItem.call(this, h, task)
    })
  }

  return h(components.empty)
}

function renderDialog(h) {
  return h(
    dialog,
    {
      props: {
        value: this.showDialog,
        data: this.task
      },
      on: {
        input: () => {
          this.showDialog = false
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendingsModeration}-tasks`
    },
    [
      renderHeader.call(this, h),
      renderItems.call(this, h),
      renderDialog.call(this, h)
    ]
  )
}
